/**************************************************
 * Nombre:       Home_Propuesta_Anuncios
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import PropuestaValor from "./SubComponentes/PropuestaValor";
import Anuncios from "./SubComponentes/Anuncios";
import {useEffect, useState} from "react";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";
import {obtenerProximoEvento} from "../../../CodigoNegocio/Eventos/obtenerProximoEvento";

const Home_Propuesta_Anuncios = () => {
    const {sCell} = useResponsive()
    const [evento, setEvento] = useState({});

    useEffect(() => {

        obtenerProximoEvento().then(dox => {
            // setEscogido(dox)
            setEvento(dox)
        })

    }, []);
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        direction={'row-reverse'}
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                            <Anuncios item={evento}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: 'flex-start', mt: sCell ? 6 : 0}}>
                            <PropuestaValor/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Propuesta_Anuncios    